import {
  type ExperimentName,
  type TenantBasedExperiment,
} from 'shared/experiments/consts'
import { isMobile } from 'shared/utils/deviceClassUtils'
import { type Tenant } from 'types/shopConfig'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

export const isObjKey = <T extends object>(
  key: PropertyKey,
  obj: T
): key is keyof T => key in obj

// Only for server side scripts
export const useGetExperimentNamePerTenant = (
  experimentName: TenantBasedExperiment
): ExperimentName => {
  const { tenant, deviceClass } = usePublicConfig()

  return (
    (isObjKey(tenant, experimentName) &&
      experimentName[tenant]?.[isMobile(deviceClass) ? 'mobile' : 'desktop']) ||
    ''
  )
}

export const getExperimentNamePerTenant = (
  experimentName: TenantBasedExperiment,
  tenant: Tenant,
  deviceClass: string
): ExperimentName => {
  return (
    (isObjKey(tenant, experimentName) &&
      experimentName[tenant]?.[isMobile(deviceClass) ? 'mobile' : 'desktop']) ||
    ''
  )
}
